export const formatZip = (zip, locale = 'sv-SE') => {
    if (!zip || typeof zip !== 'string') return '';
    const trimmed = zip.trim().replace(/ /g, '');

    if (locale.match(/fi$/i)) return trimmed;

    return trimmed.replace(/(.{3})/g, '$1 ');
};
